export default __webpack_public_path__ + "b409a6f3f6d4ba8f5d606e2cedbf13b2.svg";